import axios from "axios";

export default function getSnFormatsByBranch({ id }) {
  return new Promise((resolve, reject) =>
    axios
      .get(
        `/serialnumber/system-admin/api/v1/serialnumber/${id}/get-sn-formats`
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
